import React, { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import apiClient from '../services/apiClient';
import { noteText } from '../utils/notePresentation';

export default function FavoriteNoteAction({ sourceType, sourceId, initialFavorite = false }) {
  const [favorite, setFavorite] = useState(Boolean(initialFavorite));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => setFavorite(Boolean(initialFavorite)), [initialFavorite]);

  const toggle = async () => {
    if (!sourceId || busy) return;
    const next = !favorite;
    setBusy(true);
    setError('');
    try {
      const result = await apiClient.setLibraryFavorite(sourceType, sourceId, next);
      setFavorite(result?.isFavorite === undefined ? next : Boolean(result.isFavorite));
    } catch (requestError) {
      setError(requestError.message || noteText('favoriteFailed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="note-detail-favorite-action">
      <button
        type="button"
        className={`note-detail-button note-detail-favorite-button${favorite ? ' is-favorite' : ''}`}
        aria-pressed={favorite}
        aria-label={noteText(favorite ? 'removeFavorite' : 'addFavorite')}
        disabled={busy || !sourceId}
        onClick={toggle}
      >
        <Heart size={18} fill={favorite ? 'currentColor' : 'none'} aria-hidden="true" />
      </button>
      {error && <span className="note-detail-favorite-error" role="alert">{error}</span>}
    </div>
  );
}
